import {DepartmentsList} from "./DepartmentsList";
import {DepartmentsEdit} from "./DepartmentsEdit";
import {DepartmentsCreate} from "./DepartmentsCreate";

export default {
    list: DepartmentsList,
    create: DepartmentsCreate,
    edit: DepartmentsEdit
};
